import { GoodDetails, SkuDetails, SkuProps, SkuPropValues } from './types';
export const getListDetail = (list: any[]): GoodDetails[] => {
  const gift_goods: GoodDetails[] = [];
  list.forEach((x) => {
    const goodData: GoodDetails = {
      goodId: x.good_id,
      shopID: x.shop_id,
      viewID: x.view_id,
      catId: x.cat_id,
      title: x.title,
      priceMin: x.price_min,
      priceMax: x.price_max,
      desc: x.desc,
      note: x.note,
      videoUrl: x.video_url,
      imageUrl: x.image_url,
      imageUrl1: x.image_url_1,
      imageUrl2: x.image_url_2,
      imageUrl3: x.image_url_3,
      imageUrl4: x.image_url_4,
      isInWishlist: x.is_in_wish_list,
      rate: x.rate,
      createTime: x.create_time,
      updateTime: x.update_time,
      slug: x.slug,
      skus: [],
      skuProps: [],
      goodInfos: x.good_infos,
      subTitle: x.sub_title,
      cId: x.cid,
      relateGoods: x.relate_goods,
      imageUrl5: x.image_url_5,
      imageUrl6: x.image_url_6,
      imageUrl7: x.image_url_7,
      imageUrl8: x.image_url_8,
      imageUrl9: x.image_url_9,
      discountRatio: x.discount_ratio,
      discountPriceMin: x.discount_price_min,
      discountPriceMax: x.discount_price_max
    };
    if (x.skus) {
      x.skus.forEach((y) => {
        const skuData: SkuDetails = {
          skuId: y.sku_id,
          shopId: y.shop_id,
          goodId: y.good_id,
          propsIds: y.props_ids,
          price: y.price,
          stockNum: y.stock_num,
          outId: y.out_id,
          barcode: y.barcode,
          taxRate: y.tax_rate,
          skuImage: y.sku_image,
          viewId: y.view_id,
          originalPrice: y.original_price
        };
        goodData.skus.push(skuData);
      });
    }
    if (x.sku_props) {
      x.sku_props.forEach((z) => {
        const skuProps: SkuProps = {
          propId: z.prop_id,
          propName: z.prop_name,
          imgUrl: z.img_url,
          viewId: z.view_id,
          values: []
        };
        if (z.values) {
          z.values.forEach((v) => {
            const skuPropValues: SkuPropValues = {
              valueId: v.value_id,
              propValue: v.prop_value,
              viewId: v.view_id,
              imgUrl: v.image_url
            };
            skuProps.values.push(skuPropValues);
          });
        }
        goodData.skuProps.push(skuProps);
      });
    }
    gift_goods.push(goodData);
  });
  return gift_goods;
};
